import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const SearchEpcListState = Immutable.fromJS({
	searchEpcList: [],
	activePage: 1,
	itemPerPage: 100,
	totalPage: 1
});

const searchEpcListReducer = handleActions({
	FIND_SEARCH_EPC_LIST: (state, { payload }) => {
		return state.merge({
			searchEpcList: payload.data,
			activePage: 1,
			totalPage: 1,
			itemPerPage: 100,
		})
	},
	CLEAN_SEARCH_EPC_LIST: (state, { payload }) => {
		return state.merge({
			searchEpcList: [],
			activePage: 1,
			totalPage: 1,
			itemPerPage: 100,
		})
	},	
}, SearchEpcListState);

export default searchEpcListReducer;


// WEBPACK FOOTER //
// ./src/reducers/searchEpcListReducer.js